import React from 'react';
import {t} from '@lingui/core/macro';

import {locationAPI, ILocation} from 'entities/location';
import YesNo from 'shared/ui/YesNo/YesNo';

import AdminCrudRow from '../AdminList/AdminCrudRow/AdminCrudRow';
import {renderPublishAction} from '../AdminList/publishAction';
import LocationsModal from './LocationsModal';

interface ILocationRowProps {
    item: ILocation;
}

const LocationRow: React.FC<ILocationRowProps> = ({item}) => {
    const [togglePublish] = locationAPI.useToggleLocationPublishMutation();

    const publishAction = renderPublishAction(
        item.published,
        {hide: t`Скрыть`, show: t`Опубликовать`},
        () => togglePublish({id: item.id, published: !item.published}),
    );

    return (
        <AdminCrudRow
            item={item}
            name={item.name}
            EditModal={LocationsModal}
            useDeleteMutation={locationAPI.useDeleteLocationMutation}
            deleteTexts={{
                header: t`Удаление локации`,
                title: t`Вы действительно хотите удалить локацию`,
                success: t`Локация удалена`,
            }}
            extraActions={[publishAction]}
        >
            <td>{item?.id}</td>
            <td>{item?.name}</td>
            <td>{item?.city.country.code}</td>
            <td>{item?.city.country.zone.code}</td>
            <td>{item?.city.name}</td>
            <td><YesNo condition={item?.published}/></td>
            <td>{item?.ip === null ? 'IP нет' : item.ip}</td>
        </AdminCrudRow>
    );
};

export default LocationRow;
